export var getCookie = function getCookie(name) {
  var decode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var matches = document.cookie.match(new RegExp("(?:^|; )".concat(name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1'), "=([^;]*)")));
  if (decode) {
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }
  return matches ? matches[1] : undefined;
};